import { ajvResolver } from '@hookform/resolvers/ajv'
import { AxiosError } from 'axios'
import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useCallback, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import TermSchema, { ITermFormData } from 'schema/authentication/term'
import api from 'services/api'

const useComponent = () => {
  const [disabled, setDisabled] = useState<boolean>(true)

  const { closeAlert, openAlert } = useAlert()
  const { updateUserData } = useAuth()
  const { theme } = useCustomTheme()
  const history = useHistory()

  const form = useForm<ITermFormData>({
    resolver: ajvResolver(TermSchema),
  })

  const onSubmit: SubmitHandler<ITermFormData> = useCallback(
    async (data) => {
      try {
        await api.patch('/organizations/accept-terms', {
          isAccept: true,
        })
        await updateUserData()

        return history.push('/redirect')
      } catch (err) {
        const error = err as AxiosError
        console.log((error.response!.data as any).message)
        openAlert((error.response!.data as any).message, 'error')
      }
    },
    [history]
  )

  const handleChange = (formField: any) => closeAlert()

  return {
    form,
    theme,
    disabled,
    onSubmit,
    setDisabled,
    handleChange,
  }
}

export default useComponent
